import {shuffle} from 'helpers';

export default shuffle([
  require('./hero0.jpg'),
  require('./hero1.jpg'),
  require('./hero2.jpg'),
  require('./hero3.jpg'),
]);
